import { padCep8 } from "./cepRangeAudit";

export function formatCep8(value) {
  const raw = String(value ?? "").replace(/\D+/g, "");
  const digits = raw ? padCep8(Number(raw)) : "";
  if (!/^\d{8}$/.test(digits)) return String(value ?? "");
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

export function flattenUnattended(cities = []) {
  const rows = [];
  for (const city of cities || []) {
    const gaps = city.uncovered?.length
      ? city.uncovered
      : [{ start_cep: city.start_cep, end_cep: city.end_cep, ceps: city.uncoveredCeps }];
    for (const gap of gaps) {
      rows.push({
        ibge: city.ibge || "",
        city: city.city || "",
        uf: city.uf || "",
        kind: city.kind === "partial" ? "parcial" : "sem_cerca",
        cityStart: city.start_cep || "",
        cityEnd: city.end_cep || "",
        start_cep: gap.start_cep || "",
        end_cep: gap.end_cep || "",
        ceps: Number(gap.ceps) || 0,
        municipalityCeps: Number(city.municipalityCeps) || 0,
        coveragePct: Number(city.coveragePct) || 0,
      });
    }
  }
  return rows;
}

export function unattendedToCsv(cities = []) {
  const lines = [
    [
      "ibge",
      "cidade",
      "uf",
      "tipo",
      "cep_municipio_inicial",
      "cep_municipio_final",
      "cep_nao_atendido_inicial",
      "cep_nao_atendido_final",
      "ceps_nao_atendidos",
      "ceps_municipio",
      "cobertura_pct",
    ],
  ];
  for (const row of flattenUnattended(cities)) {
    lines.push([
      row.ibge,
      row.city,
      row.uf,
      row.kind,
      row.cityStart,
      row.cityEnd,
      row.start_cep,
      row.end_cep,
      row.ceps,
      row.municipalityCeps,
      String(row.coveragePct).replace(".", ","),
    ]);
  }
  return lines
    .map((cols) => cols.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(";"))
    .join("\n");
}
